/**
 * ICON RESOLVER
 *
 * Maps Lucide icon component name strings (from YAML config) to actual
 * React component references. Used when loading configuration from YAML
 * where icons are stored as string names rather than component references.
 */

import {
  AlertCircle,
  ArrowLeftRight,
  ArrowRight,
  BarChart3,
  Banknote,
  BookOpen,
  CheckCircle2,
  ClipboardCheck,
  ClipboardList,
  Clock,
  CreditCard,
  DollarSign,
  Eye,
  File,
  FileCheck,
  FileInput,
  FileMinus,
  FileOutput,
  FileText,
  Fuel,
  Inbox,
  MapPinned,
  Navigation,
  Package,
  PackageCheck,
  Printer,
  Receipt,
  RefreshCw,
  Repeat,
  RotateCcw,
  Send,
  ShoppingBag,
  ShoppingCart,
  Truck,
  Undo2,
  Wrench,
  XCircle,
  type LucideIcon,
} from 'lucide-react';

const ICON_MAP: Record<string, LucideIcon> = {
  AlertCircle,
  ArrowLeftRight,
  ArrowRight,
  BarChart3,
  Banknote,
  BookOpen,
  CheckCircle2,
  ClipboardCheck,
  ClipboardList,
  Clock,
  CreditCard,
  DollarSign,
  Eye,
  File,
  FileCheck,
  FileInput,
  FileMinus,
  FileOutput,
  FileText,
  Fuel,
  Inbox,
  MapPinned,
  Navigation,
  Package,
  PackageCheck,
  Printer,
  Receipt,
  RefreshCw,
  Repeat,
  RotateCcw,
  Send,
  ShoppingBag,
  ShoppingCart,
  Truck,
  Undo2,
  Wrench,
  XCircle,
};

export function resolveLucideIcon(name: string): LucideIcon {
  return ICON_MAP[name] || FileText;
}
